import React, { Component } from 'react';
import './reset-password.scss';
import CommonUtility from '../../../utility/common-utilities';
import { Constants } from '../../../constants/constants';
import { Link } from 'react-router-dom'
import Path from '../../routes/routes-path';

class ResetPassword extends Component {
    state = {
        emailId: '',
        otp: [
            { value: '' },
            { value: '' },
            { value: '' },
            { value: '' }
        ],
        password: '',
        confirmPassword: '',
        isSubmit: false,
        seconds: 0
    }

    otpRef = [];

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value });
    }


    validateEmail = (event) => {

        let value = event.target.value;

        if (value) {
            let isValid = CommonUtility.validateEmail(event.target.value);
            if (!isValid)
                this.setState({ isInvalidEmail: true });
            else
                this.setState({ isInvalidEmail: false })
        } else {
            if (this.state.isInvalidEmail)
                this.setState({ isInvalidEmail: false });
        }
    }

    onChangeOtpHandler = (e, index) => {

        let otp = this.state.otp;
        let value = e.target.value;

        if (value && isNaN(value))
            return;

        otp[index].value = value;

        console.log(this.otpRef)

        this.setState({ otp: otp }, () => {

            if (value && otp.length - 1 !== index && !this.state.otp[index + 1].value)
                this.otpRef[index + 1].focus();
        });
    }

    onHandleKeyPress = (e, index) => {
        if (e.keyCode == 8) {
            if (!this.state.otp[index].value && index !== 0)
                this.otpRef[index - 1].focus();
        }
    }

    validatePassword = () => {
        if ((this.state.confirmPassword && this.state.password) && (this.state.password !== this.state.confirmPassword)) {
            this.setState({ isPasswordMismatch: true });
        } else {
            if (this.state.isPasswordMismatch)
                this.setState({ isPasswordMismatch: false });
        }

        if (this.state.password && this.state.password.length < 6) {
            this.setState({ isInvalidPassword: true });
        } else {
            this.setState({ isInvalidPassword: false });
        }
    }

    changePassword = () => {
        this.setState({ isSubmit: true });

        let otp = '';

        this.state.otp.map(item => { otp = otp + item.value });

        let payload = {
            emailId: this.state.emailId,
            OTP: otp,
            newPassword: this.state.password
        };

        if (otp.length == 4 && this.state.password && this.state.confirmPassword && !this.state.isPasswordMismatch && !this.state.isInvalidPassword) {
            if (this.props.delegate && this.props.delegate.changePassword)
                this.props.delegate.changePassword(payload);
        }
    }

    resendOtp = () => {
        this.setState({ showTimer: true }, () => this.timer(60));
        this.reset();
        let payload = { emailId: this.state.emailId };
        this.props.delegate && this.props.delegate.resendOtp && this.props.delegate.resendOtp(payload);
    }

    reset() {
        this.setState({
            otp: [
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ],
            isSubmit: false
        });
        if (this.props.isInvalidOtp)
            this.props.delegate && this.props.delegate.removeInvalidOtpErrorMesaage && this.props.delegate.removeInvalidOtpErrorMesaage();
    }

    send = () => {
        this.setState({ isSubmit: true });

        let payload = { emailId: this.state.emailId };

        if (this.state.emailId && !this.state.isInvalidEmail) {
            this.props.delegate && this.props.delegate.sendEmail && this.props.delegate.sendEmail(payload);
            this.setState({ isSubmit: false });
        }
    }

    timer(time) {
        if (time === 0) {
            this.setState({ showTimer: false });
            return;
        }
        this.setState({ seconds: time });
        return setTimeout(() => { this.timer(--time) }, 1000)
    }

    onBlurEmailInput = () => {
        if (this.props.isNotRegisteredEmail)
            this.props.delegate && this.props.delegate.removeUnRegisteredEmailErrorMessage && this.props.delegate.removeUnRegisteredEmailErrorMessage();
    }

    onFocusOtpInput = () => {
        if (this.props.isInvalidOtp)
            this.props.delegate && this.props.delegate.removeInvalidOtpErrorMesaage && this.props.delegate.removeInvalidOtpErrorMesaage();
    }

    getElementForStepOne() {

        return (
            <div>
                <div className='header'>Forgot Password ?</div>
                <div className='description'>Enter your email and you’ll receive an OTP in your email to reset your password</div>

                <div className='cw-card'>
                    <div className='cw-card-body'>

                        <div className='row'>
                            <div className='col'>
                                <label className='cw-input-label'>EMAIL ID</label>
                                <input className={`cw-input ${(this.state.isInvalidEmail
                                    && this.state.emailId) ||
                                    (this.state.isSubmit && !this.state.emailId) ||
                                    this.props.isNotRegisteredEmail ? 'invalid' : ''}`}
                                    placeholder='Enter Your Email Id'
                                    onChange={(e) => this.onChangeHandler(e, 'emailId')}
                                    onBlur={this.validateEmail}
                                    onFocus={this.onBlurEmailInput}
                                />
                                {(this.state.isInvalidEmail && this.state.emailId) ? <span className='invalid-text'>Enter valid email</span> : ''}
                                {this.state.isSubmit && !this.state.emailId ? <span className='invalid-text'>Please enter email</span> : ''}
                                {this.props.isNotRegisteredEmail && <span className='invalid-text'>This email is not registered with countingwell</span>}
                            </div>
                        </div>

                    </div>
                    <div className='cw-card-footer' onClick={this.send}>
                        <span className='footer-text'>SEND</span>
                    </div>
                </div>
            </div>
        )
    }

    getElementForStepTwo() {

        return (
            <div>
                <div className='header'>Recover Password ?</div>
                <div className='description'>
                    <span>
                        {`We’ve sent an OTP to reset your password to`} <strong>{this.state.emailId}</strong>
                    </span>
                </div>

                <div className='cw-card'>
                    <div className='cw-card-body'>

                        <div className='row'>
                            <div className='col'>
                                <label className='cw-input-label d-block'>ENTER OTP</label>

                                {this.state.otp.map((item, index) => (
                                    <input className={`otp-box text-center ${(this.state.isSubmit && !item.value) || this.props.isInvalidOtp ? 'otp-box-invalid' : ''}`} key={'otp' + index}
                                        value={item.value}
                                        ref={ref => this.otpRef[index] = ref}
                                        maxLength={1}
                                        onChange={(e) => this.onChangeOtpHandler(e, index)}
                                        onKeyDown={(e) => this.onHandleKeyPress(e, index)}
                                        onFocus={this.onFocusOtpInput} />
                                ))}

                                <div className='row'>
                                    <div className='col-8'>
                                        {this.props.isInvalidOtp && <div className='invalid-otp-text'>Oh Snap! please enter a valid OTP </div>}
                                    </div>
                                    <div className='col-4 text-right rend-otp'>
                                        {this.state.showTimer ?
                                            <span> {`Resend OTP in ${this.state.seconds}`} </span> : <span onClick={this.resendOtp} className='cursor-pointer'>Resend OTP</span>}
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>PASSWORD</label>

                                <input className={`cw-input 
                                ${this.state.isSubmit && !this.state.password || (this.state.password && this.state.isInvalidPassword) ? 'invalid' : ''}`}
                                    placeholder='Enter Your Password'
                                    onChange={(e) => this.onChangeHandler(e, 'password')} type='password'
                                    onBlur={this.validatePassword} />

                                {this.state.isSubmit && !this.state.password ? <span className='invalid-text'>Please enter password</span> : ''}
                                {this.state.password && this.state.isInvalidPassword ? <span className='invalid-text'>Please enter valid password</span> : ''}
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>CONFIRM PASSWORD</label>

                                <input className={`cw-input 
                                ${(this.state.isSubmit && !this.state.confirmPassword) || (this.state.password && this.state.confirmPassword && this.state.isPasswordMismatch) ? 'invalid' : ''}`} placeholder='Enter Your Password Again'
                                    onChange={(e) => this.onChangeHandler(e, 'confirmPassword')} type='password'
                                    onBlur={this.validatePassword} />

                                {this.state.isSubmit && !this.state.confirmPassword ? <span className='invalid-text'>Please enter confirm password</span> : ''}

                                {this.state.isPasswordMismatch && this.state.password && this.state.confirmPassword ? <span className='invalid-text'>Please enter valid confirm password</span> : ''}
                            </div>
                        </div>

                    </div>
                    <div className='cw-card-footer' onClick={this.changePassword}>
                        <span className='footer-text'>Change Password</span>
                    </div>
                </div>
            </div>
        )

    }

    getElementForStepThree() {

        return (
            <div>
                <div className='header'>Password Changed</div>
                <div className='description'>Your password has been changed successfully</div>
                <div className='pt-3'>
                    <Link to={Path.LOGIN}>
                        <div className='cw-button'><span className='cw-button-text'>Log In</span></div>
                    </Link>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className='reset-password'>


                {/* Send Email Block */}
                {this.props.activeStep == Constants.SEND_EMAIL_PAGE && this.getElementForStepOne()}

                {/* Reset password Block */}
                {this.props.activeStep == Constants.RESET_PASSWORD_PAGE && this.getElementForStepTwo()}

                {/* password Changed success Block */}
                {this.props.activeStep == Constants.RESET_PASSWORD_SUCCESS_PAGE && this.getElementForStepThree()}

            </div>
        );
    }
}

export default ResetPassword;